import { parseISO } from 'date-fns';

export const API_URL = (typeof window !== 'undefined' && window.location.hostname && !/^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname)) ? window.location.origin : process.env.REACT_APP_BACKEND_URL;

export const CURRENCY_SYMBOLS = { USD: '$', AUD: 'A$', SGD: 'S$', INR: '\u20B9', EUR: '\u20AC', GBP: '\u00A3' };

export const formatCurrencyAmounts = (byCurrency) => {
  if (!byCurrency || Object.keys(byCurrency).length === 0) return null;
  return Object.entries(byCurrency).map(([cur, amt]) => (
    `${CURRENCY_SYMBOLS[cur] || cur + ' '}${amt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  ));
};

export const getCurrencySymbol = (cur) => CURRENCY_SYMBOLS[cur] || cur + ' ';

export const parseDate = (d) => {
  if (!d) return null;
  try { return typeof d === 'string' ? parseISO(d) : d; } catch { return null; }
};
